<pui-sub-header>
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div>
      <button pui-button variant="secondary" (click)="onGoBack()">
        <pui-icon left icon="arrow-left" />
        Powrót
      </button>
    </div>

    <div>
      @if(editMode){
      Edytuj Osobę Uprawnioną
      } @else {
      Dodaj Osobę Uprawnioną
      }
    </div>

    <div class="d-flex gap-12">
      <button pui-button variant="primary" (click)="onSubmit()">
        @if(editMode){
        Zapisz
        } @else {
        Dodaj osobę
        }
      </button>
    </div>
  </div>
</pui-sub-header>

<form class="page-container" [formGroup]="entityPersonForm">
  <pui-form-group [title]="'Dane osobowe'" [description]="'Podaj informacje ogólne, takie jak nazwa i typ podmiotu'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>Imię</pui-label>
        <input puiInput type="text" placeholder="Wprowadź imię" formControlName="firstName" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityPersonForm.get('firstName')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>

    <pui-form-row>
      <pui-form-field>
        <pui-label>Nazwisko</pui-label>
        <input puiInput type="text" placeholder="Wprowadź nazwisko" formControlName="lastName" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityPersonForm.get('lastName')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>

  <pui-form-group [title]="'Administracja'" [description]="'Określ rodzaj i przeznaczenie konta'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>Komórka uprawniona</pui-label>
        <input puiInput type="text" placeholder="Wprowadź nazwę grupy" formControlName="organization" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityPersonForm.get('organization')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>

  <pui-form-group [title]="'Dane kontaktowe'" [description]="'Podaj środki kontaktu wraz z organizacją zrzeszającą'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>E-mail</pui-label>
        <input puiInput type="text" placeholder="Wprowadź e-mail" formControlName="email" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityPersonForm.get('email')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>

    <div formArrayName="phones" class="pb-3xl">
      @for (phoneControl of phones.controls; track phoneControl; let i = $index) {

      <pui-form-row>
        <pui-form-field>
          <pui-label>Numer telefonu</pui-label>
          <input puiInput type="text" placeholder="Wprowadź numer telefonu" rqaPhoneNumber [formControlName]="i" />
          <rqa-field-error ngProjectAs="pui-form-field-error" [control]="phoneControl">
          </rqa-field-error>

          @if(phones.controls.length > 1){
          <button type="button" pui-button [variant]="'primary'" [destructive]="true" (click)="removePhone(i)">
            Usuń
          </button>
          }
        </pui-form-field>
      </pui-form-row>

      }

      <pui-form-row>
        <button type="button" pui-button style="width: 100%;" [variant]="'secondary'" (click)="addPhone()"
          [disabled]="phones.controls.length >= 5">

          <pui-icon left icon="plus" />
          Dodaj kolejny numer
        </button>
      </pui-form-row>
    </div>
  </pui-form-group>

  <pui-form-group [title]="'Informacje dodatkowe'" [description]="'Uzupełnij notatki i pomocnicze treści'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>Dodatkowe</pui-label>
        <textarea puiInput placeholder="Wpisz treść..." formControlName="additionalInfo"></textarea>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>
</form>